import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { useNavigate } from "react-router-dom";
import { getAsaanCarrier } from "../../../utils/carrierUtils";
import { getMasterData } from "../../../services/userService";

const RechargeModal = ({ show, handleClose, mode = "mobile", masterData }) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm();
  const [fetchedMasterData, setFetchedMasterData] = useState(null);

  const navigate = useNavigate();
  const isAsaan = mode === "asaan";
  const resolvedMasterData = masterData?.carriers ? masterData : fetchedMasterData;

  useEffect(() => {
    if (!show || !isAsaan || masterData?.carriers) return;

    const fetchAsaanMasterData = async () => {
      try {
        const response = await getMasterData("");
        setFetchedMasterData(response?.data);
      } catch (error) {
        console.error(error?.message);
      }
    };

    fetchAsaanMasterData();
  }, [show, isAsaan, masterData]);

  const onSubmit = (data) => {
    const encodedPhone = encodeURIComponent(data?.mobileNumber ?? "");
    if (isAsaan) {
      const asaanCarrier =
        resolvedMasterData?.carriers?.find((c) => c.name?.toLowerCase() === "asaan") ??
        getAsaanCarrier();
      navigate(`/customer/recharge-any-number/${encodedPhone}`, {
        state: { carrier_id: asaanCarrier.id },
      });
    } else {
      navigate(`/customer/recharge-any-number/${encodedPhone}`);
    }
    handleClose();
  };

  const handleChange = (value) => {
    setValue("mobileNumber", value, { shouldValidate: true });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{isAsaan ? "Asaan" : "Recharge"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3">
            <label htmlFor="mobileNumber" className="form-label">
              Mobile Number
            </label>
            <Controller
              name="mobileNumber"
              control={control}
              rules={{
                required: "Required",
                minLength: {
                  value: 7,
                  message: "Mobile number must be at least 7 digits long",
                },
                maxLength: {
                  value: 16,
                  message: "Mobile number must be at most 16 digits long",
                },
                validate: (value) => {
                  const phoneNumber = value?.replace(/[^0-9]/g, "");
                  return (phoneNumber?.length >= 7 && phoneNumber?.length <= 15) || "Mobile number must be between 7 and 15 digits";
                },
              }}
              render={({ field }) => (
                <>
                  <PhoneInput
                    className="form-control"
                    international
                    countryCallingCodeEditable={false}
                    defaultCountry="AF"
                    value={field.value}
                    {...(!isAsaan && { countries: ["AF", "TR", "NP"] })}
                    onChange={handleChange}
                  />
                  {errors?.mobileNumber && <small className="text-danger">{errors.mobileNumber.message}</small>}
                </>
              )}
            />
          </div>
          <div className="text-center mt-4">
            <button
              type="submit"
              className="rounded-pill btn btn-primary"
              style={{ minWidth: "60%", padding: "10px 28px" }}
            >
              Submit
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default RechargeModal;
